import {
  Form,
  GuaranteeFilter as Filter,
  guaranteeDefaultFilter,
  columns,
  initialValues,
  Details,
} from 'modules/guarantee';
import {
  CreateScene,
  DeleteScene,
  DetailsScene,
  EntityNav,
  EntityScene,
  ModelScene,
  IndexScene,
  UpdateScene,
} from 'components';
import type { Guarantee } from 'modules/guarantee/types';
import { agencyPermissions } from './permissions';
import { ListExport } from 'components/ListActions';
import { copyGuarantee } from 'modules/guarantee/util';

const model = {
  endpoint: 'guarantee/local/agency/',
  title: 'Agency guarantee',
  pluralTitle: 'Agency guarantees',
  entityTitle: (g: Guarantee) => g.number,
  permissions: agencyPermissions,
};

export const route = {
  path: 'agency',
  element: <ModelScene {...model} />,
  children: [
    {
      index: true,
      element: (
        <IndexScene
          defaultFilter={guaranteeDefaultFilter}
          columns={columns}
          toolbar={<ListExport />}
          storageKey="guarantee_agency"
          filterFields={<Filter />}
        />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form global={false} />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: (
        <EntityScene>
          <EntityNav
            nav={[
              {
                to: '',
                end: true,
                children: 'Details',
              },
              {
                to: 'update',
                children: 'Update',
                perm: model.permissions?.change,
              },
            ]}
          />
        </EntityScene>
      ),
      children: [
        {
          index: true,
          element: (
            <DetailsScene heading={null}>
              <Details global={false} />
            </DetailsScene>
          ),
        },
        {
          path: 'update',
          element: (
            <UpdateScene heading={null} createPath="../../create" deletePath="../delete" copy={copyGuarantee}>
              <Form global={false} />
            </UpdateScene>
          ),
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
